import { motion } from 'framer-motion';
import data from '../data/data.json';

const SKILL_CATEGORIES = {
  'PyTorch': { color: '#E8956D', type: 'AI & ML' },
  'TensorFlow': { color: '#E8956D', type: 'AI & ML' },
  'Machine Learning': { color: '#E8956D', type: 'AI & ML' },
  'Python': { color: '#E8956D', type: 'AI & ML' },
  'React': { color: '#2D1753', type: 'Frontend' },
  'TypeScript': { color: '#2D1753', type: 'Frontend' },
  'JavaScript': { color: '#2D1753', type: 'Frontend' },
  'HTML/CSS': { color: '#2D1753', type: 'Frontend' },
  'Node.js': { color: '#3a7050', type: 'Backend' },
  'FastAPI': { color: '#3a7050', type: 'Backend' },
  'REST APIs': { color: '#3a7050', type: 'Backend' },
  'SQL': { color: '#5040a0', type: 'Data' },
  'MongoDB': { color: '#5040a0', type: 'Data' },
  'pm4py': { color: '#5040a0', type: 'Analytics' },
  'Signal Processing': { color: '#c97348', type: 'Biosignals' },
  'ESP32': { color: '#c97348', type: 'Hardware' },
  'Docker': { color: '#6b5580', type: 'DevOps' },
  'Git': { color: '#6b5580', type: 'Tools' },
  'Figma': { color: '#c97348', type: 'Design' },
  'Streamlit': { color: '#E8956D', type: 'Data Apps' },
};

export default function Skills() {
  const allSkills = data.skills;
  const half = Math.ceil(allSkills.length / 2);
  const row1 = allSkills.slice(0, half);
  const row2 = allSkills.slice(half);

  const row1Doubled = [...row1, ...row1, ...row1, ...row1];
  const row2Doubled = [...row2, ...row2, ...row2, ...row2];

  return (
    <section
      id="skills"
      style={{
        padding: '3.5rem 0',
        borderTop: '1px solid var(--border)',
        borderBottom: '1px solid var(--border)',
        background: 'linear-gradient(180deg, rgba(250,246,238,0.5) 0%, rgba(247,190,161,0.08) 50%, rgba(250,246,238,0.5) 100%)',
        position: 'relative',
        overflow: 'hidden',
      }}
    >
      <style>{`
        .marquee-track {
          display: flex;
          gap: 1.25rem;
          width: max-content;
        }
        .marquee-container {
          overflow: hidden;
          position: relative;
          width: 100%;
          mask-image: linear-gradient(to right, transparent 0%, black 8%, black 92%, transparent 100%);
          -webkit-mask-image: linear-gradient(to right, transparent 0%, black 8%, black 92%, transparent 100%);
        }
        .marquee-container:hover .marquee-track {
          animation-play-state: paused !important;
        }
        .skill-pill {
          display: inline-flex;
          align-items: center;
          gap: 0.5rem;
          padding: 0.55rem 1.25rem;
          border-radius: 100px;
          background: rgba(255, 255, 255, 0.75);
          backdrop-filter: blur(8px);
          -webkit-backdrop-filter: blur(8px);
          border: 1px solid var(--border);
          font-size: 0.85rem;
          font-weight: 500;
          color: var(--text);
          white-space: nowrap;
          box-shadow: 0 2px 8px rgba(45, 23, 83, 0.03);
          transition: all 0.25s var(--ease-out);
        }
        .skill-pill:hover {
          background: #fff;
          border-color: var(--accent);
          transform: translateY(-2px);
          box-shadow: 0 6px 16px rgba(232, 149, 109, 0.2);
        }
      `}</style>

      {/* Row 1: Leftward Scrolling */}
      <div className="marquee-container" style={{ marginBottom: '1.25rem' }}>
        <motion.div
          className="marquee-track"
          animate={{ x: ['0%', '-50%'] }}
          transition={{
            duration: 32,
            ease: 'linear',
            repeat: Infinity,
          }}
        >
          {row1Doubled.map((skill, i) => {
            const cat = SKILL_CATEGORIES[skill] || { color: 'var(--accent)', type: 'Tech' };
            return (
              <span key={i} className="skill-pill" data-cursor-hover>
                <span
                  style={{
                    width: '6px',
                    height: '6px',
                    borderRadius: '50%',
                    background: cat.color,
                  }}
                />
                {skill}
              </span>
            );
          })}
        </motion.div>
      </div>

      {/* Row 2: Rightward Scrolling */}
      <div className="marquee-container">
        <motion.div
          className="marquee-track"
          animate={{ x: ['-50%', '0%'] }}
          transition={{
            duration: 34,
            ease: 'linear',
            repeat: Infinity,
          }}
        >
          {row2Doubled.map((skill, i) => {
            const cat = SKILL_CATEGORIES[skill] || { color: 'var(--accent)', type: 'Tech' };
            return (
              <span key={i} className="skill-pill" data-cursor-hover>
                <span
                  style={{
                    width: '6px',
                    height: '6px',
                    borderRadius: '50%',
                    background: cat.color,
                  }}
                />
                {skill}
              </span>
            );
          })}
        </motion.div>
      </div>
    </section>
  );
}
